module.exports = __webpack_public_path__ + "static/images/callout_1.b8c7b7c5e1a1c2295ffe2a20b7549fc8.jpg";